/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoryWithVerticals
 */
export interface CategoryWithVerticals {
    /**
     * 
     * @type {string}
     * @memberof CategoryWithVerticals
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryWithVerticals
     */
    label: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CategoryWithVerticals
     */
    verticals: Array<CategoryWithVerticalsVerticalsEnum>;
}


/**
 * @export
 */
export const CategoryWithVerticalsVerticalsEnum = {
    Strategy: 'STRATEGY',
    Freelancer: 'FREELANCER'
} as const;
export type CategoryWithVerticalsVerticalsEnum = typeof CategoryWithVerticalsVerticalsEnum[keyof typeof CategoryWithVerticalsVerticalsEnum];


/**
 * Check if a given object implements the CategoryWithVerticals interface.
 */
export function instanceOfCategoryWithVerticals(value: object): value is CategoryWithVerticals {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('verticals' in value) || value['verticals'] === undefined) return false;
    return true;
}

export function CategoryWithVerticalsFromJSON(json: any): CategoryWithVerticals {
    return CategoryWithVerticalsFromJSONTyped(json, false);
}

export function CategoryWithVerticalsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryWithVerticals {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'verticals': json['verticals'],
    };
}

export function CategoryWithVerticalsToJSON(value?: CategoryWithVerticals | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'label': value['label'],
        'verticals': value['verticals'],
    };
}

